<template>
  <div class="orderPayment">
    <!-- 支付界面 -->
    <div class="all-center-box">
      <div class="w-1500" v-loading="loading">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link to="/orderPayment">订单完成</router-link>
        </div>
        <div class="order-payment-main" v-if="orderMsg.order">
          <div class="order-infos">
            <div class="box">
              <div class="txt">
                订单已生成（订单号：<em>{{ orderMsg.order.serialNumber }}</em
                >）
              </div>
              <div class="txt">
                订单生成时间：{{ orderMsg.order.whenCreated }}&emsp;订购人：{{
                  orderMsg.contacter
                }}
              </div>
              <div class="desc">
                <div class="price">
                  应付金额：<em>¥{{ orderMsg.order.totalPrice }}</em>
                </div>
                <div class="txt">
                  根据支付时间的不同，发货日可能会有变化。请尽快支付，并在支付完成订单状态变为【已处理】时再次确认最终发货日。<br />
                  若您选择了闪达服务，为确保及时送达，<em
                    >建议您在30分钟内完成付款。</em
                  ><br />
                  过期后此单将自动取消，请在此日期之前支付。<br />
                  <!-- 配送公司：<span>暂无</span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="payment-select">
            <div class="box">
              <div class="title">选择支付方式</div>
              <div class="select">
                <label @click="paysInfo('weapp')">
                  <img src="../../assets/images/wx-icon.png" alt="微信支付" />
                  <em>微信支付</em>
                  <input type="radio" name="paymentRadio" value="微信支付" />
                </label>
                <label @click="paysInfo('alipay')">
                  <img
                    src="../../assets/images/zfb-icon.png"
                    alt="支付宝支付"
                  />
                  <em>支付宝支付</em>
                  <input type="radio" name="paymentRadio" value="支付宝支付" />
                </label>
                <label @click="paysInfo('unionpay')">
                  <img
                    src="../../assets/images/unionPay-icon.png"
                    alt="银联支付"
                  />
                  <em>银联支付</em>
                  <input type="radio" name="paymentRadio" value="银联支付" />
                </label>
                <label @click="paysInfo('offline')">
                  <img src="../../assets/images/xianxia.png" alt="线下支付" />
                  <em>线下支付</em>
                  <input type="radio" name="paymentRadio" value="线下支付" />
                </label>
              </div>
            </div>
          </div>
          <div class="detailed">
            <div class="box">
              <a class="click" @click="orderDetail()">查看订单详情</a>
              <span class="show-click" @click="detailedShow"
                >{{ detailedTitle
                }}<i
                  :style="{ transform: detailed ? 'rotate(180deg)' : '' }"
                ></i
              ></span>
            </div>
          </div>
          <div class="detailed-main" v-show="detailed">
            <div class="address">
              收货地址: {{ orderMsg.contacter }} {{ orderMsg.contactPhone }}
              {{ orderMsg.receiverAddress }}
            </div>
            <div class="shop-info">
              <div class="infos">
                <ul>
                  <li class="th">
                    <span></span>
                    <span>商品名称</span>
                    <span>型号</span>
                    <span>单价</span>
                    <span>数量</span>
                    <span>发货日</span>
                    <span>小计（金额）</span>
                  </li>
                  <!-- <li class="alert-info-txt">共 <em>{{orderMsg.creatOrderStoreGoods.length}}</em> 件商品
										<router-link to="" class="chk">立即查看</router-link>
									</li> -->
                  <li class="tr">
                    <template
                      v-for="(item, index) in orderMsg.creatOrderStoreGoods"
                    >
                      <div class="box">
                        <span>
                          <img style="width: 5rem" :src="item.goodsCoverUrl" />
                          <!-- <i :style="`background-image:url(${item.goodsCoverUrl})`"></i> -->
                        </span>
                        <span>{{ item.goodsName }}</span>
                        <span>型号:{{ item.specDetail }}</span>
                        <span>¥{{ item.price }}</span>
                        <span>x{{ item.quantity }}</span>
                        <span>暂无</span>
                        <span>￥{{ item.totalAmt }}</span>
                      </div>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wx-layer" v-if="show" :class="{ on: show }">
      <div class="box">
        <div class="title">微信支付<span @click="clickHide"></span></div>
        <div class="main">
          <div class="time">
            距离二维码过期还剩<em>44</em>秒<br />过期后请刷新页面重新获取二维码。
          </div>
          <img src="../../assets/images/erweima.png" alt="微信支付二维码" />
          <div class="alert-info-txt">
            请打开手机“微信-发现-扫一扫”<br />扫描上方二维码完成本次支付
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderStore,
  unifiedorder,
  orderDetail,
  apiPayFlow
} from '@/common/http.js';
import { message } from '@/common/common.js';
import { getOrderPay } from '../../common/http';
export default {
  name: 'orderPayment',
  data () {
    return {
      show: false,
      detailed: false,
      detailedTitle: '展开明细',
      orderMsg: {},
      params: {},
      loading: false,
    }
  },
  mounted () {
    this.params = JSON.parse(decodeURIComponent(this.$route.query.obj));
    if (this.params.orderPay) { //订单去支付
      this.getDetail(this.params);
    } else {
      this.getOrderMsg(this.params)
    }
  },
  methods: {
    getDetail (orderMsg) {
      orderStore({
        id: orderMsg.id
      }).then(res => {

        if (res.result) {
          let obj = res.data.rows[0];
          this.orderMsg = {
            order: {
              serialNumber: obj.uid,
              whenCreated: obj.whenCreated,
              totalPrice: obj.orderGateway.payAmt,
            },
            contacter: obj.orderExt.receiverName,
            contactPhone: obj.orderExt.receiverPhone,
            receiverAddress: obj.orderExt.addressDetail,
            creatOrderStoreGoods: obj.orderGoods,
            id: obj.id
          }
        }
      })
    },
    // 查看详情
    orderDetail () {
      this.$router.push({
        path: '/orderDetails',
        name: 'orderDetails',
        query: {
          uid: this.orderMsg.order.serialNumber
        }
      });
    },
    getOrderMsg (orderMsg) {
      orderDetail().then(res => {
        let obj = res.data.rows[0];
        this.orderMsg = {
          order: {
            serialNumber: obj.uid,
            whenCreated: obj.whenCreated,
            totalPrice: obj.orderGateway.payAmt,
          },
          contacter: obj.orderExt.receiverName,
          contactPhone: obj.orderExt.receiverPhone,
          receiverAddress: obj.orderExt.addressDetail,
          creatOrderStoreGoods: obj.orderGoods,
          id: obj.id
        }
      })
    },
    clickShow () {
      let $this = this;
      $this.loading = true;
      let type = 1;
      if (this.params.orderPay) { //订单去支付
        type = 5
      }
      unifiedorder({
        ptype: 10,
        rid: this.params.id,
        type: type,
      }).then(res => {
        $this.loading = false;
        // console.log('支付', JSON.parse(res.data.pay_sign).body)
        if (res.result) {
          const pay_sign = JSON.parse(res.data.pay_sign).body
          let obj = {
            pay_sign: pay_sign,
            id: res.data.uid,
          }
          let totalTime = 0;
          let timer = setInterval(() => {
            totalTime += 5000;
            if (totalTime == 120000) {
              clearInterval(timer);
              this.$alert('支付超时，请前往我的订单', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.push('/meOrder')
                }
              });
            }
            apiPayFlow({
              uid: res.data.uid
            }).then(res1 => {
              if (res1.result) {
                console.log(res1.data.pList[0].state)
                if (res1.data.pList[0].state == 5) {
                  this.$store.commit('refreshCart', true)
                  this.$alert('支付成功，请前往我的订单', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.$router.push('/meOrder');
                    }
                  });
                  clearInterval(timer);
                }
              }
            })
          }, 5000)
          const routerJump = this.$router.resolve({
            name: 'buyNow',
            path: '/buyNow',
            query: obj
          })
          window.open(routerJump.href, '_blank')
          // document.querySelector('body').innerHTML = res.data.pay_sign //查找到当前页面的body，将后台返回的form替换掉body内容
          // $this.show = true;
        } else {
          message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    paysInfo (type) {
      switch (type) {
        case "weapp":
          this.$message.warning("功能开发中");
          break;
        case "alipay":
          this.$message.warning("功能开发中");
          break;
        case "unionpay":
          this.$message.warning("功能开发中");
          break;
        case "offline":
          getOrderPay({
            uid: this.orderMsg.order.serialNumber,
            payType: 13
          }).then((res => {
            if (res.result) {
              this.$message.success(res.msg);
              this.$router.push({
                path: '/offLinePay',
                name: 'offLinePay',
                query: {
                  data: this.orderMsg
                }
              });
            }
          }))
          break;

        default:
          break;
      }
    },
    clickHide () {
      this.show = false;
    },
    detailedShow () {
      let $this = this;
      if ($this.detailed == false) {
        $this.detailed = true;
        $this.detailedTitle = '收起明细';
      } else {
        $this.detailed = false;
        $this.detailedTitle = '展开明细';
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/payment/orderPayment.vue